import './App.css';
import { Provider } from 'react-redux';
import { store } from './app/store';
import AppRouter from './components/router';
import './i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AppProviders } from 'app/providers';
import { NavigationListener } from 'routes/navigationListener';


function App() {
  return (
    <AppProviders>
      <Provider store={store}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
          <NavigationListener />
          <AppRouter />
          <ToastContainer autoClose={2000} />
        </GoogleOAuthProvider>
      </Provider>
    </AppProviders>
  );
}

export default App;
